export default {
  userDetails: {},
  properties: [],
  charmSubscribedProperties: [],
  filteredProperties: [],
  charmSubscribedAndFilteredProperties: [],
  charmSubscribedNotSelectedProperties:[],
  charmUsers:[],
  agentgroups:[],
  agentGroupsIvrFlow:[],
  ringTime:{}
};
